import React from 'react';

export const UploadDocumentIcon = ({ width = 64, height = 64, color = '#3367D6' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      d="M6 2H14L20 8V21C20 21.5523 19.5523 22 19 22H6C5.4477 22 5 21.5523 5 21V3C5 2.4477 5.4477 2 6 2Z"
      stroke={color}
      strokeWidth="2"
    />

    <path
      d="M14 2V8H20L14 2Z"
      fill={color}
    />

    <path
      d="M12 17V11"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="butt"
    />

    <path
      d="M9 14L12 11L15 14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="butt"
      strokeLinejoin="miter"
    />
  </svg>
);
